import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "error"];
import { useMemo } from 'react';
import { useGetRelevantThreadsForUserQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadViewRpc.hooks';
export { GET_RELEVANT_THREADS_FOR_USER_QUERY } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadViewRpc.dfc.new';
import { sortThreadsByLatest } from '../utils/sortThreadsByLatest';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewTicketThreads } from './previewMocks';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const useTicketThreads = (ticketId, options) => {
  const {
    isPreview
  } = getIsPreview();
  const _useGetRelevantThread = useGetRelevantThreadsForUserQuery({
      skip: isPreview || !ticketId,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketId
        }
      },
      pollInterval: options !== null && options !== void 0 && options.shouldPoll ? 10000 : undefined,
      skipPollAttempt: () => document.visibilityState === 'hidden'
    }),
    {
      data,
      loading,
      error
    } = _useGetRelevantThread,
    rest = _objectWithoutPropertiesLoose(_useGetRelevantThread, _excluded);
  const threads = useMemo(() => {
    var _data$data;
    if (isPreview) {
      return getPreviewTicketThreads(ticketId).threads;
    }
    return ((_data$data = data === null || data === void 0 ? void 0 : data.data) !== null && _data$data !== void 0 ? _data$data : []).map(thread => {
      var _thread$latestMessage;
      return {
        threadId: thread.threadId,
        startedAt: thread.startedAt,
        latestMessageTimestamp: (_thread$latestMessage = thread.latestMessageTimestamp) !== null && _thread$latestMessage !== void 0 ? _thread$latestMessage : thread.startedAt,
        originalChannel: typeof thread.originalChannel === 'string' ? thread.originalChannel : null
      };
    });
  }, [data, isPreview, ticketId]);
  const latestThread = useMemo(() => {
    if (threads.length === 0) {
      return null;
    }
    return sortThreadsByLatest(threads)[0];
  }, [threads]);
  return Object.assign({
    threads,
    latestThread,
    loading: isPreview ? false : loading,
    error
  }, rest);
};